import React, { useState } from "react";
import {FC} from 'react'
import { useIntl } from "react-intl";
import { KTSVG } from "../../_metronic/helpers";
import { PageLink, PageTitle } from "../../_metronic/layout/core";
import { Configuration, OpenAIApi } from "openai";
import { setIn } from "formik";
import axios from 'axios';
import env from "ts-react-dotenv";
import { If } from "yup/lib/util/types";


const industries = ['Accounting', 'Airlines/Aviation', 'Alternative Dispute Resolution', 'Alternative Medicine', 'Animation', 'Apparel/Fashion', 'Architecture/Planning', 'Arts/Crafts', 'Automotive', 'Aviation/Aerospace', 'Banking/Mortgage', 'Biotechnology/Greentech', 'Broadcast Media', 'Building Materials', 'Business Supplies/Equipment', 'Capital Markets/Hedge Fund/Private Equity', 'Chemicals', 'Civic/Social Organization', 'Civil Engineering', 'Commercial Real Estate', 'Computer Games', 'Computer Hardware', 'Computer Networking', 'Computer Software/Engineering', 'Computer/Network Security', 'Construction', 'Consumer Electronics', 'Consumer Goods', 'Consumer Services', 'Cosmetics', 'Dairy', 'Defense/Space', 'Design', 'E-Learning', 'Education Management', 'Electrical/Electronic Manufacturing', 'Entertainment/Movie Production', 'Environmental Services', 'Events Services', 'Executive Office', 'Facilities Services', 'Farming', 'Financial Services', 'Fine Art', 'Fishery', 'Food Production', 'Food/Beverages', 'Fundraising', 'Furniture', 'Gambling/Casinos', 'Glass/Ceramics/Concrete', 'Government Administration', 'Government Relations', 'Graphic Design/Web Design', 'Health/Fitness', 'Higher Education/Acadamia', 'Hospital/Health Care', 'Hospitality', 'Human Resources/HR', 'Import/Export', 'Individual/Family Services', 'Industrial Automation', 'Information Services', 'Information Technology/IT', 'Insurance', 'International Affairs', 'International Trade/Development', 'Internet', 'Investment Banking/Venture', 'Investment Management/Hedge Fund/Private Equity', 'Judiciary', 'Law Enforcement', 'Law Practice/Law Firms', 'Legal Services', 'Legislative Office', 'Leisure/Travel', 'Library', 'Logistics/Procurement', 'Luxury Goods/Jewelry', 'Machinery', 'Management Consulting', 'Maritime', 'Market Research', 'Marketing/Advertising/Sales', 'Mechanical or Industrial Engineering', 'Media Production', 'Medical Equipment', 'Medical Practice', 'Mental Health Care', 'Military Industry', 'Mining/Metals', 'Motion Pictures/Film', 'Museums/Institutions', 'Music', 'Nanotechnology', 'Newspapers/Journalism', 'Non-Profit/Volunteering', 'Oil/Energy/Solar/Greentech', 'Online Publishing', 'Other Industry', 'Outsourcing/Offshoring', 'Package/Freight Delivery', 'Packaging/Containers', 'Paper/Forest Products', 'Performing Arts', 'Pharmaceuticals', 'Philanthropy', 'Photography', 'Plastics', 'Political Organization', 'Primary/Secondary Education', 'Printing', 'Professional Training', 'Program Development', 'Public Relations/PR', 'Public Safety', 'Publishing Industry', 'Railroad Manufacture', 'Ranching', 'Real Estate/Mortgage', 'Recreational Facilities/Services', 'Religious Institutions', 'Renewables/Environment', 'Research Industry', 'Restaurants', 'Retail Industry', 'Security/Investigations', 'Semiconductors', 'Shipbuilding', 'Sporting Goods', 'Sports', 'Staffing/Recruiting', 'Supermarkets', 'Telecommunications', 'Textiles', 'Think Tanks', 'Tobacco', 'Translation/Localization', 'Transportation', 'Utilities', 'Venture Capital/VC', 'Veterinary', 'Warehousing', 'Wholesale', 'Wine/Spirits', 'Wireless', 'Writing/Editing']


const openAiApiKey = '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'
console.log("API Key: ", openAiApiKey)
const configuration = new Configuration({
  apiKey: openAiApiKey,
})
const openai = new OpenAIApi(configuration)


// async function getRecommendedIndustryFromDescription(description: string) {

//   // if (!configuration.apiKey) {
//   //   res.status(500).json({
//   //     error: {
//   //       message: "OpenAI API key not configured, please follow instructions in README.md",
//   //     }
//   //   });
//   //   return;
//   // }

//   const prompt = "The following is an elevator pitch for a startup and the industry it falls into:\n\n"+description+"\n\nEnglish industry name:"
//   const model = "text-davinci-003"
//   console.log("Model: ", model)
//   console.log("Prompt: ", prompt)


//   const response = await openai.createCompletion({
//     model: model,
//     prompt: prompt,
//     temperature: 0,
//     max_tokens: 20,
//     top_p: 1.0,
//     frequency_penalty: 0.0,
//     presence_penalty: 0.0,
//   })
//   const recommendedIndustry = response.data.choices[0].text
//   return recommendedIndustry as string
// }

async function getRecommendedIndustryFromDescription(description: string) {
  try {
    const requestHeaders = {
      Authorization: `Bearer ${openAiApiKey}`,
      'Content-Type': 'application/json',
    }
    console.log(typeof openAiApiKey)
    console.log(openAiApiKey)
    console.log(`Headers:`)
    console.log(requestHeaders)
    const response = await axios.post(
      'https://api.openai.com/v1/completions',
      {
        model:  "text-davinci-003",
        prompt: `The following is an elevator pitch for a startup and the industry it falls into:\n\n${description}\n\nEnglish industry name:`,
        max_tokens: 20,
        temperature: 0.5,
        // n: 1,
        // stop: '\n',
      },
      {
        headers: requestHeaders
      }
    )

    const recommendedIndustry = response.data.choices[0].text.trim();
    return recommendedIndustry;
  } catch (error) {
    console.error(error);
    return null;
  }
}


// Define which form field name belong to each step
// Array Indices correspond to step ids
const stepsFormFields = ['name', 'description', 'industry']


interface IFormData {
  name: string,
  description: string,
  industry: string,
  mainFactor: string,
}


const NewStartupPage: FC = () => {
  const [step, setStep] = useState<number>(0)

  const initialFormData:IFormData = {name: '', description: '', industry: '', mainFactor: ''}
  const [formData, setFormData] = useState<IFormData>(initialFormData)
  const [recommendedIndustry, setRecommendedIndustry] = useState<string>('')

  const descriptionMaxLength = 500

  const [timeoutRef, setTimeoutRef] = useState<NodeJS.Timeout | undefined>(undefined);
  const handleDescriptionChange = (event: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>) => {
      const newValue = event.target.value
      if (timeoutRef)
        clearTimeout(timeoutRef)
      setFormData(formData=>({ ...formData, description: newValue }))
      setTimeoutRef(
        setTimeout(async () => {
          console.log("Starting industry auto-detection...")
          console.log("Description for auto-detection:", newValue)
          const recommendedIndustry = await getRecommendedIndustryFromDescription(newValue)
          if (recommendedIndustry) {
            // setFormData(formData=>({ ...formData, industry: recommendedIndustry }))
            setRecommendedIndustry(recommendedIndustry)
            console.log("Detected industry: " + recommendedIndustry)
          }
          console.log("Function called after 3 seconds");
        }, 3000)
    )
  }

  const handleFormDataChange = (event: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement>)=>{
    const {name, value} = event.target
    setFormData(formData=>({ ...formData, [name]:value }))
    }
    


  return (
  <>
    <button type="button"
      className="btn btn-primary"
      data-bs-toggle="modal"
      data-bs-target="#kt_modal_1"
    >
      Launch form
    </button>
    <button type="button" className="btn btn-light" onClick={() => setStep(0)}>Reset Form</button>
    <div className="modal fade" id="kt_modal_1" data-bs-backdrop="static" data-bs-keyboard="false" tabIndex={-1}>
      <div className="modal-dialog modal-lg" >
        <div className="modal-content" style={{transition: 'height 1s ease-out, background-color 1s ease-out'}}>
          <div className="modal-header">
            <h5 className="modal-title">New Startup</h5>
            <div
              className="btn btn-icon btn-sm btn-active-light-primary ms-2"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              <KTSVG
                path="/media/icons/duotune/arrows/arr061.svg"
                className="svg-icon svg-icon-2x"
              />
            </div>
          </div>
          <div className="modal-body" style={{transition: 'height 1s ease-out, background-color 1s ease-out'}}>
            <div className="container-fluid">
              
              <div className="row justify-content-md-center">
                <div className="col-md-8">
                  <div className="mb-10">
                  <p>
                    Please provide some information about your new startup.
                    You can skip questions and quit the questionnaire at any time.
                  </p>
                  </div>

                  <form>
              
                    { step >= 0 && (
                      <div className="mb-10">
                        <input
                          name="name"
                          type="text"
                          className="form-control form-control-lg"
                          placeholder="What is your startup called?"
                          onChange={handleFormDataChange}
                        />
                      </div>
                    )}

                    { step >= 1 && (
                      <div className="mb-10">
                        <label className="form-label">Description / Elevator pitch</label>
                        <textarea
                          name="description"
                          className="form-control"
                          placeholder="Briefly describe your product or service"
                          maxLength={descriptionMaxLength}
                          onChange={handleFormDataChange}
                        />
                        <p className="text-end text-muted">{formData.description.length}/{descriptionMaxLength}</p>
                      </div>
                    )}
                    
                    { step >= 2 && (
                      <div className="mb-10">
                        <label htmlFor="industriesDataList" className="form-label">Industry</label>
                        { recommendedIndustry !== '' ?
                          <p className="">AI recommendation: <span className="fw-bolder text-decoration-underline">{recommendedIndustry}</span></p>
                          : null
                        }
                        <input 
                          name="industry"
                          className="form-control"
                          list="datalistOptions"
                          id="industriesDataList"
                          placeholder="Type to search..."
                          onChange={handleFormDataChange}
                        />
                        <datalist id="datalistOptions">
                          {industries.map((i) => <option value={i} />)}
                        </datalist>
                      </div>
                    )}

                  </form>

                </div>
              </div>
            </div>
          </div>
          <div className="modal-footer">
            {/* <button
              type="button"
              className="btn btn-light"
              data-bs-dismiss="modal"
            >
              Close
            </button> */}

            {/* SKIP STEP BUTTON */}
            { step < stepsFormFields.length - 1 ?
              <button type="button" className="btn btn-light" onClick={() => setStep(Math.min(step+1, stepsFormFields.length-1))}>
                Skip
              </button>
              : null }

            {/* SAVE AND PROCEED BUTTON */}
            { step < stepsFormFields.length - 1 && formData[stepsFormFields[step] as keyof IFormData] !== '' ?
              <button type="button" className="btn btn-primary" onClick={() => setStep(Math.min(step+1, stepsFormFields.length-1))}>
                Save & Proceed
              </button>
              : null }

              {/* SAVE AND FINISH BUTTON */}
              { step == stepsFormFields.length - 1 ?
                <button type="submit" className="btn btn-success">
                  Save & Finish
                </button>
                : null }

          </div>
        </div>
      </div>
    </div>
  </>
  )
}


const breadCrumbs: Array<PageLink> = [
  {
    title: 'Startups',
    path: '/startups/new',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]



const NewStartupWrapper: FC = () => {
  const intl = useIntl()
  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>{intl.formatMessage({id: 'MENU.NEW_STARTUP'})}</PageTitle>
      <NewStartupPage />
    </>
  )
}

export {NewStartupWrapper}
